import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';

import './DoubleStakes.scss';
import Icon from '../../Icon/Icon';
import StakeInput from '../../StakeInput/StakeInput';

interface DoubleStakeProps {
  stakeSelection?: { selection: string, amount:number }
  noCombinableBets?: false,
  selectedSlip?: number,
  stakes?:{ totalStake: number, singleStake: number },
  onClick?: Function,
  handleClose?: Function,
  handleChange: Function,
  isQuickBet?: boolean,
  /**Different behavior if show warning stakes are not displayed, but a warning */
  showWarning?: boolean
  /**Usefull when we need to change to different stakes */
  selectedStake?: string,
  /**If more than 1 draw selected the translation is different */
  selectedDraws?: number,
  /**Changes selected stake if you want to use the stakeInputs */
  changeSelectedStake?: Function,
  quickBetValid?: boolean
}

export default function DoubleStakes(
  {
    isQuickBet=false,
    handleClose,
    handleChange,
    stakes,
    showWarning,
    selectedStake,
    selectedDraws,
    changeSelectedStake,
    quickBetValid=true
  }: DoubleStakeProps) {
  const { t } = useTranslation();

  return (
    <div className="slip-form__stake-options">
      {
        isQuickBet && !showWarning && (
          <div className="slip-form__stakes">
            <div className="slip-form__total-stake">
              <span>{ selectedDraws > 1 ? t('betslip.stakePerDraw') :t('betslip.totalStake') }</span>
              { !quickBetValid && (<Icon icon="warningFilled" className="slip-form__warning-icon" />) }
              <StakeInput
                rule="lotto.single"
                type="betslip"
                defaultValue={ stakes.totalStake.toString() || '0' }
                name="totalStake"
                onChange={ handleChange }
                onFocus={ (name) => changeSelectedStake(name) }
                className= {
                  classNames({
                    'slip-form__stakes--selected': selectedStake === 'totalStake'
                  })
                }
              />
            </div>
            <div className="slip-form__single-stake">
              <span>{ t('betslip.perBet') }</span>
              { !quickBetValid && (<Icon icon="warningFilled" className="slip-form__warning-icon" />) }
              <StakeInput
                rule="lotto.single"
                type="bet"
                defaultValue={ stakes.singleStake.toString() || '0' }
                name="singleStake"
                onChange={ handleChange }
                onFocus={ (name) => changeSelectedStake(name) }
                className= {
                  classNames({
                    'slip-form__stakes--selected': selectedStake === 'singleStake'
                  })
                }
              />
            </div>
          </div>
        )
      }
      {
        isQuickBet && showWarning && (
          <div className="slip-form__warning-message">
            <Trans i18nKey="betslip.quickBetWarning">
              <strong></strong>
            </Trans>

            <Icon icon="close" className="slip-form__close-warning" onClick={ handleClose } />
          </div>
        )
      }
    </div>
  );
}
